/**
 * Logger utility for conditional debug logging
 *
 * Webpack automatically removes debug logs in production builds
 * via dead code elimination when NODE_ENV=production
 *
 * @package WooAIChatbot
 */
const DEBUG = process.env.NODE_ENV === 'development';
/**
 * Logger utility with conditional debug output
 */
export const logger = {
    /**
     * Debug logging (only in development)
     * Automatically removed in production builds
     */
    debug: (...args) => {
        if (DEBUG) {
            console.log('[WAC]', ...args);
        }
    },
    /**
     * Error logging (always logged, even in production)
     */
    error: (...args) => {
        console.error('[WAC ERROR]', ...args);
    },
    /**
     * Warning logging (always logged)
     */
    warn: (...args) => {
        console.warn('[WAC WARNING]', ...args);
    },
};
export default logger;
